module.exports = __webpack_public_path__ + "static/img/KPblue_KCC-05.2a96612e.png";